import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TableModule } from "ngx-easy-table";
import {
  NbButtonModule,
  NbCardModule,
  NbCheckboxModule,
  NbIconModule,
  NbLayoutModule,
  NbSelectModule,
  NbChatModule,
  NbInputModule,
  NbRadioModule,
  NbAlertModule,
  NbDialogModule,
  NbAccordionModule,
  NbContextMenuModule,
  NbFormFieldModule,
  NbTabsetModule,
  NbAutocompleteModule,
  NbSpinnerModule,
  NbStepperModule,
  NbToggleModule,
  NbTooltipModule,
  NbUserModule,
  NbDatepickerModule,
  NbListModule,
  NbPopoverModule,
} from "@nebular/theme";
import { TranslateModule } from "@ngx-translate/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

const nabModules = [
  NbCardModule,
  NbSelectModule,
  NbIconModule,
  NbCheckboxModule,
  NbButtonModule,
  NbLayoutModule,
  NbChatModule,
  NbInputModule,
  NbRadioModule,
  NbAlertModule,
  NbAccordionModule,
  NbContextMenuModule,
  NbFormFieldModule,
  NbTabsetModule,
  NbAutocompleteModule,
  NbSpinnerModule,
  NbStepperModule,
  NbToggleModule,
  NbTooltipModule,
  NbUserModule,
  NbDatepickerModule,
  NbListModule,
  NbPopoverModule,
  NbInputModule,
  NbSelectModule,
  NbCheckboxModule,
  NbTabsetModule,
  NbTooltipModule,
  NbAutocompleteModule,
  NbSpinnerModule,
  NbListModule,
  NbDatepickerModule,
  NbPopoverModule,
  NbCardModule,
  NbIconModule,
  NbRadioModule,
  NbFormFieldModule,
  NbInputModule,
  NbButtonModule,
  NbToggleModule,
];
@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    TableModule,
    NbDialogModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
  ],
  exports: [
    [...nabModules],
    TableModule,
    NbDialogModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
  ],
})
export class SharedModule {}
